import BookmarkHandler from './handlers/bookmark-handler';
import CopyHandler from './handlers/copy-handler';
import FavoriteHandler from './handlers/favorite-handler';
import PlayHandler from './handlers/play-handler';
import TafsirHandler from './handlers/tafsir-handler';

const AyahToolInitiator = {
  init({
    surah, btnTafsirAyah, btnPlayAyah, btnBookmarkAyah, btnFavoriteAyah, btnCopyAyah,
  }) {
    TafsirHandler.init(surah, btnTafsirAyah);
    PlayHandler.init(surah, btnPlayAyah);
    BookmarkHandler.init(btnBookmarkAyah);
    FavoriteHandler.init(surah, btnFavoriteAyah);
    CopyHandler.init(surah, btnCopyAyah);
  },
};

export default AyahToolInitiator;
